module.exports = __webpack_public_path__ + "img/card-salary.215ff00b.png";